module.exports = __webpack_public_path__ + "static/media/grillme_home_edit_quiz.efc4b3b2.png";